import alterDate from '../../utils/dates/alterDate';
import formatDate from '../../utils/dates/formatDate';

/**
 * Sets default profile DOB
 * @param {Object} holder Healthcare Applicant
 * @param {Boolean} isHealth Whether is product health or not
 */
function setDefaultProfileDob(holder, isHealth) {
  holder.age = isHealth ? 35 : 65;
  const date = alterDate({ years: -holder.age })
    .toISOString()
    .slice(0, 10);
  holder.dob = formatDate({
    date,
    inputFormat: 'yyyy-MM-dd',
    outputFormat: 'MM/dd/yyyy',
  });
}

export default setDefaultProfileDob;
